import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import SwapVert from '@mui/icons-material/SwapVert';
import { Button, Grid } from '@mui/material';
import { ActivityCard } from './components/activity-card';
import { CreateActivityDialog } from './components/create-activity-dialog';
import { EmptyActivitiesList } from './components/empty-activity-list';
import { ReorderDialog } from './components/reorder-dialog';
import type { Activity, Plan } from '@/data/idp/plans/interfaces';

interface ActivityListProps {
  plan: Plan;
  activities: Activity[];
}

export const ActivityList = ({ plan, activities }: ActivityListProps) => {
  const canReorder = activities.length > 1;
  const [isReorderDialogOpen, setIsReorderDialogOpen] = useState(false);
  const [isCreateActivityDialogOpen, setIsCreateActivityDialogOpen] =
    useState(false);

  const handleAddActivity = () => {
    setIsCreateActivityDialogOpen(true);
  };

  const handleReorderActivities = () => {
    setIsReorderDialogOpen(true);
  };

  return (
    <>
      <Grid container spacing={2} mt={2} mb={1} className="media-print-hide">
        <Button
          startIcon={<AddIcon />}
          onClick={handleAddActivity}
          variant="contained"
        >
          Adicionar atividade
        </Button>
        {canReorder && (
          <Button
            onClick={handleReorderActivities}
            startIcon={<SwapVert />}
            variant="outlined"
          >
            Reordenar atividades
          </Button>
        )}
      </Grid>
      {activities.length === 0 && <EmptyActivitiesList />}
      <Grid container spacing={2} columns={{ md: 3 }}>
        {activities.map((activity) => (
          <Grid size={1} key={activity.id}>
            <ActivityCard activity={activity} planStatus={plan.status} />
          </Grid>
        ))}
      </Grid>
      {isReorderDialogOpen && (
        <ReorderDialog
          activities={activities}
          planId={plan.id}
          onClose={() => setIsReorderDialogOpen(false)}
        />
      )}
      {isCreateActivityDialogOpen && (
        <CreateActivityDialog
          onClose={() => setIsCreateActivityDialogOpen(false)}
          planId={plan.id}
        />
      )}
    </>
  );
};
